// Libraries
import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {CalendarIntegrationJobCategory, CalendarIntegrationModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// App
import AccountCalendarForm, {
  AccountCalendarFormFields,
} from '@shared/modules/AccountCalendar/forms/AccountCalendarForm';

export interface CalendarIntegrationFormFields {
  calendarIntegrationId?: number;
  organizationId: string;
  projectStatuses: string[];
  inviteRoles: string[];
  eventNameTemplate: string;
  eventDescriptionTemplate: string;
  isEnabled: boolean;
  accountCalendarForm: AccountCalendarFormFields;
  jobCategories: CalendarIntegrationJobCategory[];
}

const edit = withFragment<CalendarIntegrationModel, CalendarIntegrationFormFields>(
  (calendarIntegration) => {
    return {
      calendarIntegrationId: _.toNumber(calendarIntegration.id),
      organizationId: calendarIntegration.organizationId,
      jobCategories: calendarIntegration.jobCategories,
      projectStatuses: calendarIntegration.projectStatuses,
      inviteRoles: calendarIntegration.inviteRoles,
      eventNameTemplate: calendarIntegration.eventNameTemplate,
      eventDescriptionTemplate: calendarIntegration.eventDescriptionTemplate,
      isEnabled: calendarIntegration.isEnabled,
      accountCalendarForm: AccountCalendarForm.edit(calendarIntegration.accountCalendar),
    };
  },
  gql`
    ${AccountCalendarForm.edit.fragment}
    fragment CalendarIntegrationForm_edit on CalendarIntegration {
      id
      organizationId
      jobCategories
      projectStatuses
      inviteRoles
      eventNameTemplate
      eventDescriptionTemplate
      isEnabled
      accountCalendar {
        id
        ...AccountCalendarForm_edit
      }
    }
  `,
);

const _new = ({organizationId}: {organizationId: string}): CalendarIntegrationFormFields => {
  return {
    organizationId: _.toString(organizationId),
    projectStatuses: [],
    inviteRoles: [],
    eventNameTemplate: '',
    eventDescriptionTemplate: '',
    isEnabled: true,
    accountCalendarForm: AccountCalendarForm.new({organizationId}),
    jobCategories: [],
  };
};

const toMutation = (form: CalendarIntegrationFormFields): CalendarIntegrationFormFields => {
  return {
    calendarIntegrationId: form.calendarIntegrationId,
    organizationId: form.organizationId,
    projectStatuses: form.projectStatuses,
    inviteRoles: form.inviteRoles,
    eventNameTemplate: form.eventNameTemplate,
    eventDescriptionTemplate: form.eventDescriptionTemplate,
    isEnabled: form.isEnabled,
    accountCalendarForm: AccountCalendarForm.toMutation(form.accountCalendarForm),
    jobCategories: form.jobCategories,
  };
};

const CalendarIntegrationForm = {
  edit,
  toMutation,
  new: _new,
};

export default CalendarIntegrationForm;
